import { Toast } from 'vant'
import {
    compressImage,
    getFileSuffix,
    isValidFileType,
    UPLOAD_ACCEPT_TYPE_IMAGE_SUFFIX,
} from '@/utils/upload'
import { uploadFile } from '@/api/upload'
import { MESSAGE_NAME } from '@/constants/message'
import { sendMessage } from '@/utils/message_send'

export async function uploadImgBusiness (file) {
    try {
        const compressedFile = await compressImage(file)

        if (!compressedFile) {
            return
        }

        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '上传中'
        })

        const { url } = await uploadFile(compressedFile)

        Toast.clear()

        sendMessage({
            type: 'base',
            detailType: MESSAGE_NAME.IMAGE,
            content: {
                url,
                name: file.name,
                size: file.size,
                type: file.type
            }
        })
    } catch (err) {
        Toast.fail('上传失败')
        // eslint-disable-next-line
        console.error(err)
    }
}

export async function uploadFileBusiness (file) {
    try {
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '上传中'
        })

        const { url } = await uploadFile(file)

        Toast.clear()

        const isImage = isValidFileType(getFileSuffix(file.name), UPLOAD_ACCEPT_TYPE_IMAGE_SUFFIX)
        const detailType = isImage
            ? MESSAGE_NAME.IMAGE
            : MESSAGE_NAME.FILE

        sendMessage({
            type: 'base',
            detailType,
            content: {
                url,
                name: file.name,
                size: file.size,
                type: file.type
            }
        })
    } catch (err) {
        Toast.fail('上传失败')
        // eslint-disable-next-line
        console.error(err)
    }
}
